<template>
  <div class="devOps_producerSpaceDevtask" v-loading="loading">
    <!-- #region 表单搜索部分 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="项目体系" prop="project_system" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.systemId" collapse-tags filterable
                   placeholder="请选择项目体系" clearable>
          <el-option v-for="(key, value) in allSystem.ALLSYSTEMIDS" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称">
        <el-input :style="iptStyle" placeholder="请输入" @keyup.enter.native="formSearch('reset')" v-model="form.projectName" />
      </el-form-item>
      <el-form-item label="需求名称">
        <el-input :style="iptStyle" placeholder="请输入" @keyup.enter.native="formSearch('reset')" v-model="form.demandName" />
      </el-form-item>
      <el-form-item label="开发任务名称">
        <el-input :style="iptStyle" placeholder="请输入" @keyup.enter.native="formSearch('reset')" v-model="form.taskName" />
      </el-form-item>
      <el-form-item label="测试任务名称">
        <el-input :style="iptStyle" placeholder="请输入" @keyup.enter.native="formSearch('reset')" v-model="form.testTaskName" />
      </el-form-item>
      <el-form-item label="产品经理" prop="pm" :label-width="formLabelWidth">
        <el-select :style="iptStyle" filterable  clearable collapse-tags size="mini" v-model="form.pmId"  placeholder="请选择产品经理">
          <el-option v-for="(key, value) in allUserList.DEVUSER" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="技术负责人" prop="reviewer" :label-width="formLabelWidth">
        <el-select :style="iptStyle" filterable clearable collapse-tags size="mini" v-model="form.reviewId"  placeholder="请选择技术负责人">
          <el-option v-for="(key, value) in allUserList.DEVUSER" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="开发"   prop="developer_user" :label-width="formLabelWidth">
        <el-select :style="iptStyle" filterable clearable collapse-tags   size="mini" v-model="form.developerId"  placeholder="请选择开发">
          <el-option v-for="(key, value) in allUserList.DEVUSER" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="系统">
        <el-select :style="iptStyle" collapse-tags v-model="form.module" multiple filterable placeholder="请选择系统">
          <el-option v-for="(value, key) in allSelect.TEXTFILTERMODULES" :key="key" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="需求状态">
        <el-select :style="iptStyle" multiple filterable collapse-tags  v-model="form.demandStatus"
                   placeholder="请选择需求状态">
          <el-option v-for="(value, key) in allStatusList.ALLSTATUSTYPE2" :key="key" :label="value.value" :value="value.key" />
        </el-select>
      </el-form-item>
      <el-form-item label="任务状态">
        <el-select :style="iptStyle" multiple filterable collapse-tags v-model="form.status"
                   placeholder="请选择任务状态">
          <el-option  v-for="(value, key) in allStatusList.ALLSTATUSTYPE3" :key="value" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <!--      <el-form-item label="标签">
              <el-input :style="iptStyle" placeholder="请输入"  @keyup.enter.native="formSearch('reset')" v-model="form.tag" />
            </el-form-item>-->
      <el-form-item label="实际完成日期">
        <el-date-picker
            v-model="form.serach_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期" />
      </el-form-item>
      <div>
        <el-form-item>
          <el-button v-if="allMenuList.btn_dev_task_query" style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"
                     @click="formSearch('reset','search')">查询
          </el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button v-if="allMenuList.btn_dev_task_daily_rpt" style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"-->
<!--                     @click="getReportList()" :loading="reportLoading">日进度提交-->
<!--          </el-button>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button v-if="allMenuList.btn_dev_task_clear" style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"
                     @click="changeReset()">置空
          </el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- #endregion 表单搜索部分 -->

    <!-- #region 表格部分 -->
    <div style="height: 53vh;position: relative;">
      <el-table height="100%" stripe :header-cell-style="getCellClass" row-key="d_id" ref="multipleTable"
                :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
                @sort-change="sortChange" :data="tableData">
        <el-table-column fixed="left" prop="taskName" min-width="160" label="任务名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span @click="showDialogVisible('task', scope.row)" class="table_text_click_new">
              [{{scope.row.id}}] {{ scope.row.taskName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column fixed="left" prop="statusDesc"  align="center" width="100" label="任务状态"  :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="left" prop="demandStatus"  align="center" width="100" label="需求状态"  :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="projectSystemName" align="center" width="120" label="项目体系" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column  prop="title" label="项目名称" min-width="120" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span @click="showDialogVisible('project', scope.row)" class="table_text_click_new">
              [{{ scope.row.projectId }}] {{ scope.row.projectName }}</span>
          </template>
        </el-table-column>
        <el-table-column  prop="demandName" label="需求名称" min-width="120" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span @click="showDialogVisible('demand', scope.row)" class="table_text_click_new">
            [{{scope.row.demandId}}]  {{ scope.row.demandName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="module" align="center" width="120" label="系统" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ allSelect.TEXTMODULES[scope.row.module] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pm" align="center" width="80" label="产品经理" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.pm ? scope.row.pm.nameZh: '' }} {{ scope.row.pm ? '('+scope.row.pm.nameEn+')': '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reviewer" align="center" width="100" label="技术负责人" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.reviewer.nameZh ? scope.row.reviewer.nameZh: '' }} {{ scope.row.reviewer.nameEn ? '('+scope.row.reviewer.nameEn+')': '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="developer" align="center" width="60" label="开发" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.developer.nameZh ? scope.row.developer.nameZh: '' }} {{ scope.row.developer.nameEn ? '('+scope.row.developer.nameEn+')': '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="finishDate" sortable="custom" align="center" width="130" label="实际完成日期" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="processRate" sortable="custom" align="center" width="130" label="进度" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
    </div>
    <!-- #endregion 表格部分 -->

    <!-- #region 分页部分 -->
    <div class="block devOpsSpace_page">
      <span class="demonstration">当前页{{ currentPageLength || 0 }}条</span>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="count">
      </el-pagination>
    </div>
    <!-- #endregion -->

    <!-- #region dialog 部分 -->
    <Demand v-if="dialogVisible.demand" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.demand'
            :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" :tabid="tabid"/>
    <Task v-if="dialogVisible.task" :back="back" :dialogVisible='dialogVisible.task' :hideDialogVisible="hideDialogVisible"
          :formInfo="checkedInfo" :tabid="tabid"/>
    <ToDevelop v-if="dialogVisible.toDevelop" :dialogVisible='dialogVisible.toDevelop'
               :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <Developing v-if="dialogVisible.developing" :dialogVisible='dialogVisible.developing'
                :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <ToTest v-if="dialogVisible.toTest" :dialogVisible='dialogVisible.toTest' :hideDialogVisible="hideDialogVisible"
            :formInfo="checkedInfo" />
    <TestEnvTesting v-if="dialogVisible.testEnvTesting" :dialogVisible='dialogVisible.testEnvTesting'
                    :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <PreEnvTesting v-if="dialogVisible.preEnvTesting" :dialogVisible='dialogVisible.preEnvTesting'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <UatTesting v-if="dialogVisible.uatTesting" :dialogVisible='dialogVisible.uatTesting'
                :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <ToRelease v-if="dialogVisible.toRelease" :dialogVisible='dialogVisible.toRelease'
               :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <ProEnvTesting v-if="dialogVisible.proEnvTesting" :dialogVisible='dialogVisible.proEnvTesting'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <Online v-if="dialogVisible.online" :dialogVisible='dialogVisible.online' :hideDialogVisible="hideDialogVisible"
            :formInfo="checkedInfo" />
    <AddBug  v-if="dialogVisible.addBug" :dialogVisible='dialogVisible.addBug'
             :hideDialogVisible="hideDialogVisible" :taskid="taskid"/>
    <CreateProject v-if="dialogVisible.project" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.project'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <!-- #endregion dialog 部分 -->
    <Menu />
    <ReportList v-if="dialogVisible.report" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.report'
                :hideDialogVisible="hideDialogVisible" @change="change" :reportData="reportData"  newTitle="开发任务日报" :type="1"/>

    <RecordProject v-if="dialogVisible.record"   :back="back"  :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.record'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></RecordProject>
  </div>
</template>
<script>
import { Demand, Task, ToDevelop, Developing, ToTest, TestEnvTesting, PreEnvTesting, UatTesting, ToRelease, ProEnvTesting, Online } from './components'
import {
  postDevOpsSpaceDevTaskApi,
  getDevOpsSpaceStageSelectmapApi,
  getDevOpsSpaceDevelopDevTaskListApi, getDevOpsSpaceReportTaskListApi, postDevOpsSpaceSUbmitReportApi
} from "@/server/tops/devOps";
import { formatEnToUtf8, formatTimeToDate, formatEnToUtf8NoEn } from "@/views/tops/devOps/components/util.js";
import { getStorage, setStorage } from "@/common/utils/storage.js"
import Menu from '@/components/menu/index.vue'
import { mapState, mapMutations } from 'vuex';
import AddBug from "@/views/tops/devOps/producerSpace/components/bug/add.vue";
import CreateProject from "@/views/tops/devOps/producerSpace/components/createProject.vue";
import  ReportList from "@/views/tops/devOps/producerSpace/components/report/list.vue";
import RecordProject from "@/views/tops/devOps/producerSpace/components/recordProject.vue";
export default {
  components: {
    RecordProject,
    AddBug, Demand, Task, ToDevelop, Developing, ToTest, TestEnvTesting, PreEnvTesting, UatTesting, ToRelease, ProEnvTesting, Online, Menu, CreateProject, ReportList },
  props: {
    tabid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 表单搜索条件
      form: {
        serach_time:'',
        finishDateStart:'',
        finishDateEnd:'',
        status:['1','2'],
        demandStatus:[6,7,15],
        developerId:'',
        demandName: '',
        taskName:'',
        testTaskName:'',
        projectName:'',
        pmId: '',
        reviewId: '',
        module: '',
      },
      is_admin:false,
      // 需求列表
      tableData: [],
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      // 弹出层部分
      dialogVisible: {
        demand: false,
        task: false,
        toDevelop: false,
        developing: false,
        toTest: false,
        testEnvTesting: false,
        preEnvTesting: false,
        uatTesting: false,
        toRelease: false,
        proEnvTesting: false,
        online: false,
        addBug: false,
        project: false,
        report: false,
        record: false,
      },
      // 选中信息
      checkedInfo: {},
      cacheTableData: [],
      count: 10, // 总计
      currentPage: 1, // 当前页
      currentPageLength: 10,
      pageSize: 10, // 每页多少个
      expands: [],
      preciseSwitch: false,
      users: {},
      tableOptions: [
        {
          label: '项目体系',
          value: 'project_system'
        },
        {
          label: '需求人员',
          value: 'demander'
        },
        {
          label: '产品',
          value: 'user_pm'
        },
        {
          label: '优先级',
          value: 'priority'
        },
        {
          label: '技术评审状态',
          value: 'reviewed_status'
        },
        {
          label: '方案状态',
          value: 'p_status'
        },
        {
          label: '需求状态',
          value: 'p_issue_status'
        },
        {
          label: '创建时间',
          value: 'create_time'
        },
        {
          label: '期望上线时间',
          value: 'plt'
        },
        {
          label: '需求进度',
          value: 'progress'
        },
        {
          label: '系统',
          value: 'taskInfo.module'
        },
        {
          label: '开发',
          value: 'taskInfo.user_rd'
        },
        {
          label: '技术评审人',
          value: 'taskInfo.tech_reviewer'
        },
        {
          label: '测试',
          value: 'taskInfo.user_qa'
        },
        {
          label: '任务状态',
          value: 'taskInfo.status'
        },
        {
          label: '任务进度',
          value: 'taskInfo.task_progress'
        },
        {
          label: '期望发布时间',
          value: 'taskInfo.o_pdt'
        },
        {
          label: '实际发布时间',
          value: 'taskInfo.o_aelt'
        },
        {
          label: '计划开发开始日期',
          value: 'taskInfo.d_psdt'
        },
        {
          label: '计划开发完成日期',
          value: 'taskInfo.d_pedt'
        },
        {
          label: '计划测试开始日期',
          value: 'taskInfo.t_pstt'
        },
        {
          label: '计划测试完成日期',
          value: 'taskInfo.t_pett'
        },
        {
          label: '计划上线日期',
          value: 'taskInfo.d_plt'
        },
        {
          label: 'Issue',
          value: 'taskInfo.issue'
        }],
      taskStatusSorts: {
        '待开发': 1,
        '开发中': 2,
        '待测试': 3,
        '测试环境测试中': 4,
        '预发环境测试中': 5,
        'UAT测试中': 6,
        '生产环境测试中': 7,
        '待发布': 8,
        '已上线': 9
      },
      loading:false,
      tableLoading: false,
      reportLoading: false,
      checkedTables: ['reviewed_status','o_aelt', 'o_pdt', 'project_system', 'demander', 'user_pm', 'priority', 'p_status', 'p_issue_status', 'plt', 'progress', 'taskInfo.module', 'taskInfo.user_rd', 'taskInfo.user_qa', 'taskInfo.status', 'taskInfo.task_progress', 'taskInfo.issue'],
      taskid: '',
      back : '',
      showReport: false,
      reportData: [],
    };
  },
  async created() {
    let checkedTables = getStorage('checkedTables', 'localStorage')
    let pageSize = getStorage('pageSize', 'localStorage')
    pageSize && (this.pageSize = pageSize * 1);
    this.checkedTables = checkedTables ? checkedTables.split(',') : this.checkedTables;
    //this.users = this.allSelect.TEXTUSERSEN;
    await this.$store.dispatch('getDevopsSelect')
    await this.$store.dispatch('getDevopsSystem')
    //全部人员
    await this.$store.dispatch('getDevopsUserList',{userType:''})
    //项目状态
    await this.$store.dispatch('getDevopsStatusList',{type:''})
    await this.$store.dispatch('getDevopsMenuList',{})
    await this.$store.dispatch('getDevopsWorkOrderConfig')
  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.NEWALLSYSTEM,
          allUserList: (state) => state.devOps.NEWALLUSERLIST,
          allStatusList: (state) => state.devOps.NEWALLSTATUSLIST,
          allMenuList: (state) => state.devOps.NEWALLMENULIST,
        }
    ),
    /*需求状态 */
    pTaskStatus() {
      let str = ''
      this.form.task_issue_status.forEach(item => {
        str += item + ','
      })
      return str;
    },

  },
  watch: {
    'tableData': {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      },
      deep: true
    }
  },
  async mounted() {
    const { pid = '', tid = '', proId = '',testId = '',nd = '',ns = '', tabid  = ''} = this.$route.query;

    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';

    this.form = { ...this.form, user: username ? [username] : [], title: pid, task_title: tid ,developer_user: username ? username : ''};

    // if(this.allUserList.ALLUSERIDLIST1[username]){
    //   let defauledeveloperId= this.allUserList.ALLUSERIDLIST1[username];
    //   this.form.developerId = defauledeveloperId.toString();
    // }
    if(this.$store.state.devOps.userInfo.userId){
      let defauledeveloperId= this.$store.state.devOps.userInfo.userId;
      this.form.developerId = defauledeveloperId.toString();
    }
      if (pid || tid || proId || testId) {
        this.form.status = [];
        this.form.developerId = '';
        this.form.demandStatus = [];
        if(pid) this.form.demandName = pid;
        if(tid) this.form.taskName = tid;
        if(proId) this.form.projectName = proId;
        if(testId) this.form.testTaskName = testId;
      }


    if (nd) {
      this.form.demandStatus = [];
    }
    if(ns && ns == 4){
      this.form.status = [];
      this.form.demandStatus = [];
      this.form.developerId = '';
      if(this.allUserList.ALLUSERIDLIST1[username]){
        let defauleUserId= this.allUserList.ALLUSERIDLIST1[username];
        this.form.reviewId = defauleUserId.toString();
      }
    }
    if(ns && ns == 6){
      this.form.demandStatus = [];
      this.form.status = ['3'];
    }
    this.$nextTick(async () => {
      await this.formSearch();
      //this.autoDialogDetailPop(this.tableData)
    })
  },
  methods: {
    //...mapMutations(['filterSelect']),
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    getCellClassReport(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 判断任务状态是否可点击
    taskStatusDisabledFn(state) {
      return state === '待开发' || state === '开发中'
    },
    // 点击table自选
    onSelectTableOption() {
      this.$refs.tableOption.$el.click()
    },
    onChangeTableOption(val) {
      const tableData = this.tableData;
      setStorage('checkedTables', val, 'localStorage')
      this.tableData = []
      this.$nextTick(() => {
        this.tableData = tableData;
      })
    },
    // 扩展行
    clickRowHandle(row, column, event) { },
    // 根据进度设置颜色
    colorProgressFn(g, pg) {
      if (g >= pg) return { color: 'rgb(248, 172, 89)' }
      if (pg > g >= pg - 20) return { color: '#67C23A' }
      if (pg - 20 > g) return { color: '#F56C6C' }
      return {}
    },
    // 表单搜索
    async formSearch(type,key) {
      this.form.finishDateStart='';
      this.form.finishDateEnd='';
      if(this.form.serach_time){
        if(this.form.serach_time[0]){
          this.form.finishDateStart=this.form.serach_time[0];
        }
        if(this.form.serach_time[1]){
          this.form.finishDateEnd=this.form.serach_time[1];
        }
      }
      if(type === 'reset'){
        this.pageNo = 1;
        this.currentPage = 1;
      }
      try {
        this.$refs.multipleTable.clearSort()
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = this.currentPage
        params.pageSize = this.pageSize
        this.loading = true;
        const ret = await getDevOpsSpaceDevelopDevTaskListApi(params);
        this.tableData = ret.data;
        this.cacheTableData = ret.data;
        this.currentPageLength = ret.data.length;
        this.count = ret.count;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
    },
    // 判断是否需要直接弹详情
    autoDialogDetailPop(tableData) {
      const { pid = '', tid = '', sid = '' } = this.$route.query;
      if (!tableData.length) return;
      if (pid && !tid && !sid) { // 弹需求详情
        this.showDialogVisible('demand', tableData[0])
        return;
      }
      if (pid && tid && !sid) { // 弹任务详情
        this.showDialogVisible('task', tableData[0])
        return;
      }
      if (pid && tid && sid) { // 弹阶段详情
        this.showDialogVisible(this.allSelect.TEXTTASKSTATUSDIOLOGVISIBLE[tableData[0].taskInfo.status], tableData[0])
        return;
      }
      return;
    },
    // 格式化数据
    formatTableData(data) {
      let arr = []
      data.forEach((t, i) => {
        let obj = {
          title:t.title,
          id:t.id,
          pm:t.pm,
          project_system:t.project_system,
          module:t.module,
          d_plt:t.d_plt,
          d_title:t.d_title,
          d_user:t.d_user ,
          pedt:t.pedt,
          reviewer:t.reviewer,
          task_id:t.task_id,
          task_status:t.task_status,
          tech_reviewer:t.tech_reviewer,
          sortId: `${t.id}-${i}`,
          taskInfo: {
            id: t.task_id,
            pid:t.id ,
            title: t.d_title,
            user_rd: t.d_user,
            user_pm: t.pm,
            tech_reviewer: t.tech_reviewer,
            user_qa:t.t_user,
            module: t.module,
            status: t.task_status,
            domain: t.d_domain?t.d_domain: 'ehsy.com',
          }
        };
        /*  if (i === 0) {
            obj = { ...obj,  ...this.commonTableDataObj(t) }
          }*/
        arr.push(obj)
      })

      return arr;
    },
    // 公共部分逻辑
    commonTableDataObj(o) {
      const { title, id, pm, developer_user, module, pett, project_system, t_plt, t_title, t_user ,task_id, d_id, task_status} = o;
      return { title, id, pm, developer_user, module, pett, project_system, t_plt, t_title, t_user,task_id, d_id, task_status }
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    // 表格样式
    getRowClassReport({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "font-size: 12px;padding:6px 0;";
    },
    // 格式化tableData数据
    formatSortTableData() {
      let arr = []
      this.tableData.forEach(item => {
        if (item.id) {
          const ls = this.tableData.filter(itm => {
            return itm.sortId.startsWith(item.id)
          })
          arr.push(ls)
        }
      })
      return arr;
    },
    // 排序任务时间
    sortTaskTime(key, order) {
      let arr = this.formatSortTableData();
      let newArr = []
      arr.forEach(item => {
        let existDates = [], noExistDates = [];
        let maxDate = 0; // 找出最大日期
        item.forEach(t => {
          const currentDate = t.taskInfo[key];
          if (currentDate && maxDate < currentDate) {
            maxDate = currentDate
          }
          t.taskInfo[key] ? existDates.push(t) : noExistDates.push(t);
        })
        existDates.sort((a, b) => {
          return order === 'descending' ? b.taskInfo[key] - a.taskInfo[key] : a.taskInfo[key] - b.taskInfo[key];
        })
        let tArr = existDates.concat(noExistDates);
        let newTArr = []
        tArr.forEach((t, i) => {
          newTArr.push(i === 0 ? { ...t, maxDate } : t)
        })
        newArr.push(newTArr);
      })
      this.tableData = this.setTableDateHead(newArr, order)
    },
    // 排序需求列表
    setTableDateHead(arr, order) {
      let newArr = [], existDates = [], noExistDates = [];
      arr.forEach(t => {
        t[0].maxDate ? existDates.push(t) : noExistDates.push(t);
      })
      existDates.sort((a, b) => {
        return order === 'descending' ? b[0].maxDate - a[0].maxDate : a[0].maxDate - b[0].maxDate;
      })
      let pArr = existDates.concat(noExistDates);
      pArr.forEach(item => {
        let cacheIdx = 0;
        item.forEach((itm, index) => {
          if (index === 0) {
            const pi = item.filter((it, idx) => {
              if (it.id) {
                cacheIdx = idx;
                return true;
              }
            })
            itm = { ...pi[0], ...itm }
          }
          if (index === cacheIdx && cacheIdx !== 0) {
            itm = { sortId: itm.sortId, taskInfo: itm.taskInfo }
          }
          newArr.push(itm)
        })
      })
      return newArr;
    },
    // 排序事件
    sortChange(column) {
      const { prop, order } = column;
      this.tableData = this.cacheTableData;
      if(prop === 'planFinishDate') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.planFinishDate) - Date.parse(a.planFinishDate) : Date.parse(a.planFinishDate) - Date.parse(b.planFinishDate);
        })
      }

    },
    // 弹出模板
    async showDialogVisible(type, row , back = '') {
      console.log(56666666)
      console.log(back)
      let newRow = {...row};
      if(type === 'task'){
        if(!row.taskId){
          newRow = {...row,taskId:row.id}
        }else{
          newRow = {...row,taskId:row.taskId}
        }
      }
      if(type === 'project'){
        newRow = {name : row.projectName, id: row.projectId}
      }
      if(type === 'demand'){
        newRow = {name : row.demandName, id: row.demandId}
      }
      if (type === 'releaseing') {
        return;
      }
      await this.hideDialogVisible('', false)
      this.checkedInfo = newRow;
      this.dialogVisible[type] = true;
      this.back = back;
    },
    async change(date){
      let  params = {workDate:date};
      await getDevOpsSpaceReportTaskListApi(params).then((ret)=>{
        if(ret.status === 'success'){
          this.reportData = ret.data;
        }
      });

    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true, taskid = '') {
      this.taskid = taskid;
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      let pid = '';
      if(nextStep === 'demand'){
        pid = this.checkedInfo.id;
      }

      if (nextStep && (typeof(nextStep) === 'string')) {
        /* const params = nextStep === 'demand' ? { title: this.checkedInfo?.id} : { task_title: this.checkedInfo?.taskInfo?.id }
         const ret = await postDevOpsSpaceDevTaskApi(params);
         const tableData = this.formatTableData(ret.data) || [];
         this.checkedInfo = tableData[0];
         this.checkedInfo.next = (nextStep === 'demand')
         if(nextStep === 'demand'){
           this.checkedInfo = {id:pid};
         }
         this.$nextTick(() => {
           this.checkedInfo && (this.dialogVisible[nextStep] = true);
         })*/
        this.$nextTick(() => {
          this.dialogVisible[nextStep] = true
        })
      } else {
        search && await this.formSearch()
      }
    },
    async getReportList(){
      this.reportLoading = true;
      let  params = {workDate:this.getNowDate()};
      try{
        const ret =  await getDevOpsSpaceReportTaskListApi(params);
        if(ret.status === 'success'){
          this.reportData = ret.data;
          this.showDialogVisible('report');
        }
        this.reportLoading = false;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
        this.reportLoading = false;
      } finally {
        this.showReport = false;
        this.reportLoading = false;
      }

    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      setStorage('pageSize', val, 'localStorage')
      this.formSearch();
    },
    handleInputBlur(row,type){
      let params = {};
      params.taskId = row.task_id;
      params.taskType = 1;
      params.workDate = this.getNowDate();
      let changeVal = row[type];
      if(type === 'todayCost'){
        params.todayCost = Number(changeVal);
      }
      if(type === 'todayBugCost'){
        params.todayBugCost = Number(changeVal);
      }
      this.submitReport(params);
    },
    submitReport(params){
      postDevOpsSpaceSUbmitReportApi(params).then((res)=>{
        if(res.status === 'success'){
          this.$notify({
            message: res.message || "保存失败",
            type: "success",
          })
        }else{
          this.$notify({
            message: res.message || "保存失败",
            type: "error",
          })
        }
      });
    },
    // 分页事件
    handleCurrentChange(val) {
      this.formSearch();
    },
    changeReset(){
      this.form.status = '';
      this.form.developerId = '';
      this.form.taskName = '';
      this.form.projectName = '';
      this.form.demandName = '';
      this.form.testTaskName = '';
      this.form.pmId = '';
      this.form.reviewId = '';
      this.form.module = '';
      this.form.serach_time = '';
      this.form.demandStatus = '';



    },
    fileExport() {
      let url = `${window.location.origin}/devops/space/reporter/export?source_type=project&project_action=list`;
      for (const key in this.form) {
        const val = this.form[key];
        url += `&${key}=${this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val}`;
      }
      url += `&pageNo=${this.currentPage}&pageSize=${this.pageSize}`;
      window.location.href = url;
    },
    // 将英文名字转为中卫
    formatEnToUtf8,
    formatEnToUtf8NoEn,
    // 毫秒值转 YYYY-MM-DD HH:mm:ss
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.devOps_producerSpaceDevtask {

  .link_svg {
    position: absolute;
    left: -96px;
    top: 2px;
    transform: rotate(90deg);
    cursor: pointer;
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }


  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .dialog-footer .el-button {
    font-weight: bold;
    margin-left: 0;
    margin-right: 10px;
  }

  .form_warp .el-form-item {
    margin-bottom: 6px;
  }

  padding-top: 10px;

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
  .priority_style {
    border-radius: 5px;
    text-align: center;
    width: fit-content;
    padding: 0 5px;
    margin: auto;
  }

  .el-dialog__header {
    font-weight: bold;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
}

/* #region 滚动条部分 */
.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* #endregion 滚动条部分 */

.table_options_warp {
  position: absolute;
  z-index: 4;
  left: 20px;
  top: 22px;
  width: 20px;
  cursor: pointer;
}
.devOps_producerSpaceDevtask .el-form-item__label {
  font-weight: bold;
  font-size: 12px;
}
</style>
